import { render } from "./AccountingSetting.vue?vue&type=template&id=38b5c432"
import script from "./AccountingSetting.vue?vue&type=script&lang=js"
export * from "./AccountingSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__